export enum PBtnTableSize {
  MEDIUM = 'medium',
  SMALL = 'small',
}
